import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface MainNavContainerStyles {
    container: InjectableCss;
    mobileSearchContainer?: InjectableCss;
    staticPageContainer?: InjectableCss;
}

const styles: MainNavContainerStyles = {
    container: {
        css: css`
            background-color: #f3f3f3;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            > div:first-child {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                max-width: 4.75rem;
                            `,
                            css`
                                max-width: 4.75rem;
                            `,
                            css`
                                max-width: 4.75rem;
                            `,
                            css`
                                flex-grow: 1;
                                max-width: max-content;
                            `,
                            css`
                                flex-grow: 1;
                                max-width: max-content;
                            `,
                        ],
                        "min",
                    );
                }}
            }
        `,
    },
    mobileSearchContainer: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: auto;
                            flex-grow: 1;
                        `,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: auto;
                            flex-grow: 1;
                        `,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: auto;
                            flex-grow: 1;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                    ],
                    "min",
                );
            }}
        `,
    },
    staticPageContainer: {
        css: css`
            margin-left: auto;
            .list-wrapper {
                display: flex;
                padding: 0px;
                height: 100%;
                .links-wrapper {
                    padding-right: 1.25rem;
                    height: 50px;
                    cursor: pointer;
                }
                .links-wrapper:last-child,
                .links-wrapper-last {
                    padding-right: 0rem !important;
                }
                .links-wrapper .list-link,
                nav.links-wrapper .list-link {
                    font-size: 13px;
                    font-family: "Roboto-Medium";
                    text-transform: capitalize;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    color: ${getColor("primary")};
                }

                nav.links-wrapper {
                    height: 50px;
                    display: flex;
                    align-items: center;
                    > ul[class^="MenuStyle"] {
                        top: 100%;
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: auto;
                        `,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: auto;
                        `,
                    ],
                    "min",
                );
            }}
        `,
    },
};

const SEHeaderMainNavContainer: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...styles.container}>
        <Zone contentId={id} zoneName="MainNavigation" />
        <StyledWrapper {...styles.staticPageContainer}>
            <Zone contentId={id} zoneName="StaticPagesList" />
        </StyledWrapper>
        <StyledWrapper {...styles.mobileSearchContainer}>
            <Zone contentId={id} zoneName="MobileSearchInput" />
        </StyledWrapper>
    </StyledWrapper>
);

const headerMainNavContainer: WidgetModule = {
    component: SEHeaderMainNavContainer,
    definition: {
        group: "Common",
    },
};

export default headerMainNavContainer;
